import axios from "./Api";
import { handleQueriesString } from "../helpers/function.helper";

export const GetHistoryList = async (params: any) => {
  const queriesString = handleQueriesString(params);
  const url = `/api/app/inventory-history?MaxResultCount=40&${queriesString}`;
  const data = await axios.get(url);
  return data;
};
